/**
 * 自定义 token 操作
 * @author LiQingSong
 */
import settings from '@/config/settings';

/**
 * 获取本地Token
 */
export const getToken = () => localStorage.getItem(settings.siteTokenKey);

/**
 * 设置存储本地Token
 */
export const setToken = (token: string) => {
  clearSession();
  localStorage.setItem(settings.siteTokenKey, token);
};

/**
 * 移除本地Token
 */
export const removeToken = () => {
  localStorage.removeItem(settings.siteTokenKey);
};

/**
 * 获取本地 adminUser
 */
export const getAdminUser = <T = any>(): T | null => {
  const str = localStorage.getItem(settings.siteAdminUserKey);
  if (!str) return null;
  try {
    return JSON.parse(str) as T;
  } catch {
    return null;
  }
};

/**
 * 设置存储本地 adminUser
 */
export const setAdminUser = (adminUser: unknown) => {
  localStorage.setItem(settings.siteAdminUserKey, JSON.stringify(adminUser || {}));
};

/**
 * 移除本地 adminUser
 */
export const removeAdminUser = () => {
  localStorage.removeItem(settings.siteAdminUserKey);
};

/**
 * 获取本地 AllPermissionList（全部权限树）
 */
export const getAllPermissionList = <T = any>(): T | null => {
  const str = localStorage.getItem(settings.siteAllPermissionListKey);
  if (!str) return null;
  try {
    return JSON.parse(str) as T;
  } catch {
    return null;
  }
};

/**
 * 设置存储本地 AllPermissionList
 */
export const setAllPermissionList = (list: unknown) => {
  localStorage.setItem(settings.siteAllPermissionListKey, JSON.stringify(list || []));
};

/** Clear all identity-derived caches on sign-in, expiration and logout. */
export const clearSession = () => {
  removeToken();
  removeAdminUser();
  localStorage.removeItem(settings.siteAllPermissionListKey);
};

export const loginUrl = () => {
  const path = window.location.pathname + window.location.search + window.location.hash;
  return window.location.pathname === '/user/login' ? '/user/login' : `/user/login?redirect=${encodeURIComponent(path)}`;
};
